import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { Router, RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { SessionService } from '@yukawa/chain-main-angular-session';
import { Subject, timer } from 'rxjs';
import { finalize, takeUntil, takeWhile, tap } from 'rxjs/operators';
import { PlainObject } from 'simplytyped';


@Component({
    imports      : [
      TranslocoModule,
      MatIconModule,
      MatCardModule,
      RouterModule,
      CommonModule
    ],
    selector     : 'auth-sign-out',
    templateUrl  : './sign-out.component.html',
    styleUrls    : ['../sign-in/sign-in.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AuthSignOutComponent implements OnInit, OnDestroy
{
    private readonly _sessionService = inject(SessionService);
    private readonly _router = inject(Router);
    private readonly _translocoService = inject(TranslocoService);

    countdown = 5;

    countdownMapping: PlainObject;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor()
    {
        this.countdownMapping = {
            '=1'   : this._translocoService.translate('FORMAT.TIME.SECOND', { count: '#' }),
            'other': this._translocoService.translate('FORMAT.TIME.SECONDS', { count: '#' }),
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        const startDue = 1000;

        // Sign out, redirect after the countdown
        this._sessionService.logout({ redirectDelay: startDue + startDue * this.countdown });

        timer(startDue, startDue)
            .pipe(
                finalize(() =>
                {
                    // redirect done by app component (session changed event)
                }),
                takeWhile(() => this.countdown > 0),
                takeUntil(this._unsubscribeAll),
                tap(() => this.countdown--),
            )
            .subscribe();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
